var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          selection: _vm.selection,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "before-query-search": _vm.beforeQuerySearch,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.zoneType"),
                          prop: "partitionType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.ZONE_TYPE_LIST,
                            placeholder: _vm.$t("billingPage.zoneType"),
                          },
                          on: { change: _vm.onQueryPartitionTypeChange },
                          model: {
                            value: _vm.queryParams.partitionType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "partitionType", $$v)
                            },
                            expression: "queryParams.partitionType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.zone"),
                          prop: "partitionValue",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            value: _vm.queryParams.partitionValue,
                            placeholder: _vm.$t("billingPage.zone"),
                          },
                          on: { input: _vm.handleQueryZoneInput },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessLogisticsCompanyPostCode.country"
                          ),
                          prop: "country",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                            placeholder: _vm.$t(
                              "BusinessLogisticsCompanyPostCode.country"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.country,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "country", $$v)
                            },
                            expression: "queryParams.country",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.zoneCity"),
                          prop: "city",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            disabled: _vm.queryParams.partitionType !== "2",
                            placeholder: _vm.$t("billingPage.zoneCity"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.city,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "city", $$v)
                            },
                            expression: "queryParams.city",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.PostcodeS"),
                          prop: "postCodeFrom",
                        },
                      },
                      [
                        _c("BjInput", {
                          ref: "queryPostCodeFrom",
                          attrs: {
                            value: _vm.queryParams.postCodeFrom,
                            disabled:
                              _vm.queryParams.partitionType !== "1" &&
                              _vm.queryParams.partitionType !== "2",
                            placeholder: _vm.$t("billingPage.PostcodeS"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.handlePostCodeInput(
                                "queryParams",
                                "postCodeFrom",
                                $event,
                                "queryPostCodeFrom"
                              )
                            },
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.PostcodeE"),
                          prop: "postCodeTo",
                        },
                      },
                      [
                        _c("BjInput", {
                          ref: "queryPostCodeTo",
                          attrs: {
                            value: _vm.queryParams.postCodeTo,
                            disabled:
                              _vm.queryParams.partitionType !== "1" &&
                              _vm.queryParams.partitionType !== "2",
                            placeholder: _vm.$t("billingPage.PostcodeE"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.handlePostCodeInput(
                                "queryParams",
                                "postCodeTo",
                                $event,
                                "queryPostCodeTo"
                              )
                            },
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:USER-ONBOARDING-ADD",
                            arg: "USER-ONBOARDING-ADD",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("createText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onBulkDel },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onImport },
                      },
                      [_vm._v(_vm._s(_vm.$t("importDataText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "partitionType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.ZONE_TYPE_LIST.bjGet(
                                                  scope.row.partitionType
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.zoneType"),
                    prop: "partitionType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.ZONE_TYPE_LIST,
                      placeholder: _vm.$t("billingPage.zoneType"),
                    },
                    model: {
                      value: _vm.form.partitionType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "partitionType", $$v)
                      },
                      expression: "form.partitionType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BusinessLogisticsCompanyPostCode.country"),
                    prop: "country",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                      placeholder: _vm.$t(
                        "BusinessLogisticsCompanyPostCode.country"
                      ),
                    },
                    model: {
                      value: _vm.form.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "country", $$v)
                      },
                      expression: "form.country",
                    },
                  }),
                ],
                1
              ),
              _vm.form.partitionType === "2"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.zoneState"),
                        prop: "state",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("billingPage.zoneState"),
                          maxlength: "100",
                          "show-word-limit": true,
                        },
                        model: {
                          value: _vm.form.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "state", $$v)
                          },
                          expression: "form.state",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.partitionType === "2"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.zoneCity"),
                        prop: "city",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("billingPage.zoneCity"),
                          maxlength: "100",
                          "show-word-limit": true,
                        },
                        model: {
                          value: _vm.form.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "city", $$v)
                          },
                          expression: "form.city",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.zone"),
                    prop: "partitionValue",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      value: _vm.form.partitionValue,
                      placeholder: _vm.$t("billingPage.zone"),
                      maxlength: "50",
                      "show-word-limit": true,
                    },
                    on: { input: _vm.handleFormZoneInput },
                  }),
                ],
                1
              ),
              _vm.isFormPostCodeRangeVisible
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.PostcodeS"),
                        prop: "postCodeFrom",
                      },
                    },
                    [
                      _c("BjInput", {
                        ref: "formPostCodeFrom",
                        attrs: {
                          value: _vm.form.postCodeFrom,
                          maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                          placeholder: _vm.$t("billingPage.PostcodeS"),
                          "show-word-limit": true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handlePostCodeInput(
                              "form",
                              "postCodeFrom",
                              $event,
                              "formPostCodeFrom"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFormPostCodeRangeVisible
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.PostcodeE"),
                        prop: "postCodeTo",
                      },
                    },
                    [
                      _c("BjInput", {
                        ref: "formPostCodeTo",
                        attrs: {
                          value: _vm.form.postCodeTo,
                          maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                          placeholder: _vm.$t("billingPage.PostcodeE"),
                          "show-word-limit": true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handlePostCodeInput(
                              "form",
                              "postCodeTo",
                              $event,
                              "formPostCodeTo"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.DEPRemark"),
                    prop: "remark",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      placeholder: _vm.$t("billingPage.DEPRemark"),
                      rows: 4,
                      "show-word-limit": true,
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }